/* Materparade: barra colore a gradiente (dal bianco al nero).
   Trasforma i pulsanti .mp-pick in una barra: si trascina il cursore o si clicca in un punto.
   I pulsanti restano nel DOM (nascosti): la barra li "clicca", così sezione 3D e configuratore funzionano senza modifiche.
   Ordine: tre onde dal chiaro allo scuro, con le tonalità in sequenza dentro ogni onda; Bianco primo, Nero ultimo. */
(function () {
  'use strict';
  if (window.__mpBar) return;
  window.__mpBar = true;

  var ORDER = ['Bianco','Grigio perla','Rosa confetto','Rosa cipria','Pesca','Sabbia','Avorio','Giallo girasole','Giallo limone','Verde pistacchio','Verde salvia','Acquamarina','Azzurro cielo','Lavanda','Grigio pietra','Rosa antico','Rosso papavero','Corallo','Terracotta','Nocciola','Arancio ambra','Ocra','Oro antico','Verde oliva','Verde prato','Verde smeraldo','Turchese','Fucsia','Antracite','Bordeaux','Rosso melograno','Ruggine','Cioccolato','Verde bosco','Petrolio','Blu cobalto','Blu notte','Viola ametista','Melanzana','Nero'];

  function build(host) {
    if (host._mpBar) return;
    var btns = [].slice.call(host.querySelectorAll('.mp-pick'));
    if (btns.length < 2) return;
    var byName = {};
    btns.forEach(function (b) { byName[b.getAttribute('data-mp-color')] = b; });
    var seq = ORDER.map(function (n) { return byName[n]; }).filter(Boolean);
    btns.forEach(function (b) { if (seq.indexOf(b) < 0) seq.push(b); });
    var n = seq.length;
    var stops = seq.map(function (b, i) { return b.getAttribute('data-mp-hex') + ' ' + (i / (n - 1) * 100).toFixed(2) + '%'; });

    var bar = document.createElement('div');
    bar.className = 'mp-bar';
    bar.innerHTML = '<div class="mp-bar__track" aria-hidden="true"></div>' +
      '<input class="mp-bar__input" type="range" min="0" max="' + (n - 1) + '" step="1" value="0" aria-label="Colore della Mater">' +
      '<span class="mp-bar__tip" aria-hidden="true"></span>';
    var track = bar.querySelector('.mp-bar__track');
    var input = bar.querySelector('.mp-bar__input');
    var tip = bar.querySelector('.mp-bar__tip');
    track.style.background = 'linear-gradient(90deg,' + stops.join(',') + ')';

    function paint(i) {
      var b = seq[i];
      bar.style.setProperty('--thumb', b.getAttribute('data-mp-hex'));
      bar.style.setProperty('--r', (i / (n - 1)).toFixed(4));
      input.setAttribute('aria-valuetext', b.getAttribute('data-mp-color'));
      tip.textContent = b.getAttribute('data-mp-color');
    }
    var cur = -1;
    input.addEventListener('input', function () {
      var i = parseInt(input.value, 10);
      if (i === cur) return;
      cur = i; paint(i); seq[i].click();
    });
    function sync() {
      for (var i = 0; i < n; i++) {
        if (seq[i].getAttribute('aria-pressed') === 'true') {
          if (i !== cur) { cur = i; input.value = i; paint(i); }
          return;
        }
      }
    }
    var mo = new MutationObserver(sync);
    btns.forEach(function (b) { mo.observe(b, { attributes: true, attributeFilter: ['aria-pressed'] }); });
    input.addEventListener('pointerdown', function () { bar.classList.add('is-drag'); });
    window.addEventListener('pointerup', function () { bar.classList.remove('is-drag'); });
    window.addEventListener('pointercancel', function () { bar.classList.remove('is-drag'); });

    paint(0);
    host.classList.add('has-bar');
    host.insertBefore(bar, host.firstChild);
    host._mpBar = true;
    sync();
  }

  function init() {
    [].slice.call(document.querySelectorAll('.mp-vstep__picker, .mp-conf__colors, .mp-hero__picker')).forEach(build);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();